module.exports = __webpack_public_path__ + "img/w_delete_normal.9ce41449.svg";